// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"54e8e726","610":"c2e76fee","749":"015025d3","782":"c2e76fee","797":"c2e76fee"}[chunkId] + ".chunk.css";
};